import React from 'react';

import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

export default function BackgroundImage(props: { fileName: string }) {
    const data = useStaticQuery(
        graphql`
            query {
                allFile(filter: { sourceInstanceName: { eq: "images" } }) {
                    edges {
                        node {
                            relativePath
                            childImageSharp {
                                gatsbyImageData(
                                    placeholder: NONE
                                    layout: FULL_WIDTH
                                )
                            }
                        }
                    }
                }
            }
        `
    );

    let image = data.allFile.edges.find(
        ({ node }: any) => node.relativePath === props.fileName
    )?.node;

    return image ? (
        <GatsbyImage
            image={image.childImageSharp.gatsbyImageData}
            style={{
                position: `absolute`,
                width: `100%`,
                height: `100%`,
                zIndex: `-2`,
            }}
            alt=''
        />
    ) : (
        <></>
    );
}
